// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"922":"cb769d9a","1414":"16e9c398","4313":"16e9c398","6767":"16e9c398","8271":"16e9c398","8365":"16e9c398","9042":"4281b9b0","9572":"16e9c398"}[chunkId] + ".chunk.css";
};